import { render, staticRenderFns } from "./AdvacnedSettings.vue?vue&type=template&id=0ca09ed9"
import script from "./AdvacnedSettings.vue?vue&type=script&lang=ts"
export * from "./AdvacnedSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports